import { ComparisonPageTemplate } from "@/components/ComparisonPageTemplate";
import { Brain, Users, Clock } from "lucide-react";

const CSWvsAnkiApp = () => {
  return (
    <ComparisonPageTemplate
      platformName="AnkiApp"
      platformUrl="https://www.ankiapp.com"
      seoDescription="Compare CSW and AnkiApp flashcard applications. Discover why CSW offers collaborative study without paid subscriptions."
      seoKeywords="CSW vs AnkiApp, AnkiApp alternative, free flashcard app, spaced repetition free"
      canonicalUrl="https://csw.live/flash-cards/csw-vs-ankiapp/"
      heroDescription="Looking for a free alternative to AnkiApp? CSW offers collaborative study and gamified learning without subscription fees."
      alternativeDescription="While AnkiApp offers spaced repetition, CSW provides collaborative and gamified learning completely free."
      background="AnkiApp is a commercial spinoff of Anki with ready-made decks and adaptive review intervals."
      pros={[
        { text: "Ready-made deck library" },
        { text: "Adaptive review intervals" },
        { text: "Cross-device sync" }
      ]}
      cons={[
        { text: "Most features require paid plan" },
        { text: "No collaborative elements" },
        { text: "Subscription required for full access" }
      ]}
      cswFeatures={[
        { text: "Free Full Access", available: true },
        { text: "Collaborative Study", available: true },
        { text: "Gamified Learning", available: true },
        { text: "No Subscription", available: true }
      ]}
      competitorFeatures={[
        { text: "Free Full Access", available: false },
        { text: "Collaborative Study", available: false },
        { text: "Gamified Learning", available: false },
        { text: "No Subscription", available: false }
      ]}
      benefits={[
        { icon: Brain, title: "Completely Free", description: "Access all features without subscriptions." },
        { icon: Users, title: "Study Together", description: "Collaborate with friends in real-time." },
        { icon: Clock, title: "Engaging Experience", description: "Gamified elements make learning fun." }
      ]}
      forStudentsText="CSW provides what AnkiApp charges for—plus collaborative study and gamification."
      pricingText="AnkiApp requires paid subscriptions. CSW offers unlimited access free."
      competitorPrice="$24.99/year"
    />
  );
};

export default CSWvsAnkiApp;
